// extracted by mini-css-extract-plugin
export var orderDetails = "_sc-2";
export var orderImage = "_sc-1";
export var orderMeta = "_sc-3";
export var orderSummary = "_sc-0";
export var rightArrow = "_sc-4";